import LegalPage from "../components/LegalPage";

const SECTIONS = [
  {
    h: "Concept site notice",
    ps: [
      "barverse.com is the brand home of Barverse, a modern sports bar experience connected to Tacoverse. Imagery on this site consists of architectural renderings of the planned Barverse concept, and any location marked as demo data is a placeholder until approved locations are published.",
    ],
  },
  {
    h: "Menus & availability",
    ps: [
      "Drinks and food shown on this site reflect the confirmed Barverse beverage program and the Tacoverse food menu at the time of publishing. Menu availability varies by location, and items may change. Prices are not displayed on barverse.com; ordering and pricing live at tacoverse.com.",
    ],
  },
  {
    h: "Alcohol",
    ps: [
      "You must be 21 or older to purchase or consume alcoholic beverages. Please drink responsibly. Zero-proof options are available through the Tacoverse program.",
    ],
  },
  {
    h: "Inquiries, not reservations",
    ps: [
      "The group inquiry form is a request for follow-up, not an instant booking, reservation or confirmation. Your event is only confirmed when a member of the Barverse team confirms it with you directly.",
    ],
  },
  {
    h: "Sports programming",
    ps: [
      "Game availability and programming vary by Barverse location and are subject to change. Not every game or sporting event is guaranteed to be shown.",
    ],
  },
  {
    h: "Third-party links",
    ps: [
      " tacoverse.com and its menu pages are operated by the Tacoverse brand. Any online ordering you complete there is handled entirely by Tacoverse.",
    ],
  },
];

export default function Terms() {
  return (
    <LegalPage
      testid="terms-page"
      path="/terms"
      title="Terms"
      description="Terms of use for barverse.com — menus and availability, alcohol policy, inquiries and sports programming."
      updated="October 2026"
      intro="Short and plain: this site introduces the Barverse experience, collects group inquiries and points food ordering to Tacoverse. Using the site means you accept the terms below."
      sections={SECTIONS}
    />
  );
}
